<script setup>
import {ref} from 'vue'
import {useAppStore} from '@/stores/appStore'

const props = defineProps({
    options: {
        type: Object,
        required: true
    }
})

const emit = defineEmits(['hide-modal'])

const appStore = useAppStore()

const iframeHtml = ref(`
<link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.8/dist/css/bootstrap.min.css" rel="stylesheet">

<base href="${appStore.websiteEndpoint}">

${props.options.value}

<div style="position: fixed; top: 0; left: 0; width: 100%; height: 100%;"></div>
`)
</script>

<template>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">{{ options.label }}</h4>

                <button type="button" class="btn-close" @click="emit('hide-modal')" aria-label="Close"></button>
            </div>
            <div class="modal-body">

                <iframe
                    :srcdoc="iframeHtml"
                    style="width: 100%; height: 100%; border: none"
                />

            </div>
            <div class="modal-footer"></div>
        </div>
    </div>
</template>